export default {
  errors: {
    AUTH: {
      NO_PASSWORD_FOR_SOCIAL_MEDIA:
        'Intentando verificar contraseña para una cuenta registrada con red social',
    },
    DRAWER_ITEMS: {
      NATIVE_ITEMS_CANNOT_BE_DELETED: 'Los items nativos no pueden ser eliminados',
      REDIRECT_URL_AND_LOGO_URL_CANNOT_BE_UPDATED:
        'No se puede modificar los campos redirectUrl y logoUrl para este recurso',
    },
    EXTERNAL_API: {
      INVALID_PARTNER: 'Partner inválido',
      TUCAN_SERVICE_ERROR: 'Error del servicio Tucan: {{message}}',
    },
    FDL: {
      ERROR_CREATING_FIREBASE_LINK: 'Error al crear el enlace de Firebase: {{message}}',
    },
    MDM: {
      API_KEY_NOT_DEFINED: 'La clave de API de MDM no está definida',
    },
    MEMBERSHIP: {
      DIFFERENT_TO_LAST_MEMBERSHIP:
        'Intentando eliminar un nivel de membresía diferente al último nivel',
    },
    PRIZES: {
      REWARD_HAS_BEEN_EXECUTED: 'La recompensa ya ha sido ejecutada',
      NO_PRIZES_FOR_LEVEL: 'No hay premios para el nivel dado ({{level}})',
      USER_HAD_WELCOME_PRIZE: 'El usuario ya ha recibido un premio de bienvenida',
    },
    USER_POLL: {
      QUESTION_WITHOUT_ANSWERS: 'La pregunta de la encuesta no puede ser activada sin respuestas',
    },
    COUPONS: {
      DAILY_COUPON_ALREADY_USED: 'Ya utilizaste tu cupón diario, mañana se habilitan nuevamente :)',
    },
    USER_LOYALTY: {
      CUSTOM_MESSAGE: 'Ya posee una visita el día de hoy. Intente generar una visita mañana.',
    },
    USERS: {
      CODE_USED: 'El código de validación ya ha sido utilizado',
    },
    STORE: {
      SERIE_REQUIRED: 'Si el RUT se comparte con otra marca, ambas deben tener una serie distinta',
      SERIE_DUPLICATE: 'Ya existe una marca con este RUT y esta serie',
    },
    PARKING_CONFIG: {
      FIXED_EXISTS:
        'Ya existe un beneficio de parking fijo activo para uno de los niveles seleccionados',
      FREE_FIXED_OVERLAP:
        'El período de vigencia se solapa con otro Fijo e ilimitado en un Rango de Fechas',
      ICON_REQUIRED: 'El ícono es requerido',
      INVALID: 'Los datos de la configuración de parking no son válidos',
      TYPE_IMMUTABLE: 'El tipo de beneficio no se puede cambiar después de crear la configuración',
      FREE_FIXED_IMMUTABLE:
        'El check de parking libre no se puede cambiar después de crear la configuración',
      VALIDITY_LOCKED:
        'La vigencia de un parking fijo libre vencido no se puede editar. Creá uno nuevo.',
      STORE_REQUIRED: 'Debés seleccionar al menos una marca',
      TAG_REQUIRED: 'Debés seleccionar al menos un tag',
      QR_IDENTITY_REQUIRED: 'Completá Id sistema, Id emisor e Id beneficio',
      QR_IDENTITY_DUPLICATE: 'Ya existe un beneficio de parking con esa identidad QR',
      QR_SYSTEM_INVALID: 'El Id sistema debe ser numérico de hasta 4 dígitos',
      QR_ISSUER_INVALID: 'El Id emisor debe ser numérico de hasta 4 dígitos',
      QR_BENEFIT_INVALID: 'El Id beneficio debe ser un dígito del 0 al 9',
    },
    APPLE_WALLET: {
      ERROR_GENERATING_APPLE_PASS: 'Error al generar el Apple Pass: {{message}}',
      ERROR_SENDING_NOTIFICATION_APPLE_PASS:
        'Error al enviar la notificación Apple Pass: {{message}}',
      ERROR_UPDATING_APPLE_PASS: 'Error al actualizar el Apple Pass: {{message}}',
    },
    FCM: {
      SEND_ALL_WITH_0_MESSAGES: 'Función enviar a todos llamada con 0 mensajes',
    },
    GOOGLE_WALLET: {
      ERROR_CREATING_OR_UPDATING_PASS_CLASS:
        'Error al crear o actualizar la clase de acceso de Google Wallet: {{message}}',
      ERROR_ADDING_MESSAGE_TO_PASS:
        'Error al agregar un mensaje al acceso de Google Wallet: {{message}}',
      ERROR_CHECKING_PASS_STATUS:
        'Error al verificar el estado del acceso de Google Wallet: {{message}}',
      ERROR_UPDATING_CLASS_ID: 'Error al actualizar el Class ID de Google Wallet: {{message}}',
    },
    RAY: {
      NOT_WORKING: 'El servicio RAY no está funcionando: {{message}}',
    },
    EmailAddressInUse: 'El email ya está en uso',
    GeoJsonRequired: 'El GeoJson del campo "{{geoJsonField}}" no puede estar vacío',
    GeoJsonInvalidFormat: 'El formato del campo "{{geoJsonField}}" es inválido',
    ImageRequired: 'La imagen del campo "{{imageField}}" no puede estar vacía',
    ImmutableFields:
      'No se pueden modificar los siguientes campos para este/estos recurso/s: {{fields, list}}',
    IncorrectPassword: 'La contraseña es incorrecta',
    NonUniqueField: 'El campo "{{field}}" con valor "{{value}}" ya está en uso',
    ResourceNotFound: 'El recurso "{{resource}}" no fue encontrado',
    SendingEmailError: 'Error al enviar el email: {{message}}',
    Unauthorized: 'Desautorizado',
    UserAlreadyVerified: 'El usuario con email "{{email}}" ya está verificado',
    UserDisabled: 'El usuario está deshabilitado',
    UserNotVerified: 'La cuenta del usuario con id "{{id}}" aún no está verificada',
  },
  tags: {
    ALL: 'Global',
    BRANDS: 'Marcas',
    LEVELS: 'Niveles',
    FILTER: 'Filtros',
    CATEGORY: 'Categoría',
    DISCOUNT: 'Descuento',
  },
  parking: {
    listTitle: 'Parking',
    createTitle: 'Nueva configuración de parking',
    editTitle: 'Editar configuración de parking',
    deleteTitle: '¿Está seguro que desea eliminar la configuración "{{title}}"?',
    create: 'Crear',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    activate: 'Activar',
    deactivate: 'Desactivar',
    newConfig: 'Nuevo parking',
    columns: {
      id: 'ID',
      benefit: 'Beneficio',
      type: 'Tipo de parking',
      mode: 'Modo',
      active: 'Activo',
      levels: 'Nivel',
      icon: 'Ícono',
      image: 'Imagen',
    },
    yes: 'Sí',
    no: 'No',
    emptyValue: '-',
    types: {
      fixed: 'Fijo por Nivel',
      free_fixed: 'Fijo e ilimitado en un Rango de Fechas',
      unlock: 'Extra',
      unlock_qr: 'Extra QR especial',
      unlimited: 'Extra Ilimitado',
    },
    kinds: {
      fixed: 'Fijo por Nivel',
      free_fixed: 'Fijo e ilimitado en un Rango de Fechas',
      unlock: 'Extra',
      unlock_qr: 'Extra QR especial',
      unlimited: 'Extra Ilimitado',
    },
    priority: {
      tooltip: 'Prioridad {{rank}} de 4 · {{status}}',
    },
    status: {
      outOfValidity: 'Fuera de vigencia',
    },
    typeHints: {
      fixed: 'Horas base automáticas otorgadas diariamente por proceso nocturno a cada nivel.',
      free_fixed: 'Parking libre hasta las 23:59h cada día y sin requerir lectura de QR.',
      unlock: 'Se otorga al alcanzar el monto configurado con una o más facturas.',
      unlock_qr: 'Desbloqueo al escanear un QR especial de 22 dígitos. Solo se configuran Id sistema, Id emisor e Id beneficio.',
      unlimited: 'Parking libre todo el día de la lectura hasta las 23:59h con lectura de QR.',
    },
    unlockModes: {
      single_invoice: 'Factura única',
      daily_accumulation: 'Factura acumulable',
      free: 'Libre',
    },
    tabs: {
      rules: 'Reglas',
      presentation: 'Presentación',
      scope: 'Niveles',
    },
    hints: {
      rules: 'Definí cómo se otorga el beneficio de parking.',
      applicationScope:
        'Si no elegís alcance, el beneficio aplica a todas las marcas y tags.',
      typeLockedOnEdit: 'El tipo no se puede modificar una vez creada la configuración.',
      isFree: 'El beneficio se asigna como parking ilimitado mientras esté vigente.',
      isFreeLockedOnEdit: 'El parking libre no se puede modificar una vez creada la configuración.',
      validity: 'El beneficio solo se otorga y aplica entre estas fechas, inclusive.',
      validityLocked: 'La vigencia venció. Para otra campaña creá un beneficio nuevo.',
      presentation: 'Textos e imágenes que ve el usuario en la app.',
      scope: 'Seleccioná a qué niveles aplica este beneficio.',
      levelsWithMinutes:
        'Seleccioná los niveles y el tiempo de parking (horas y minutos) para cada uno.',
      levelsUnlimited: 'Seleccioná los niveles que reciben este beneficio ilimitado.',
      shortTitle: 'Visible en el detalle del beneficio en la parte central.',
      title:
        'Visible en el listado y en el detalle del beneficio (admite negritas, seleccionando el texto).',
      additionalText: 'Subtítulo en listados y en el detalle del beneficio',
      description: 'Texto explicativo al pie del detalle',
      icon: 'Ícono en listados de beneficios',
      image: 'Imagen de cabecera en el detalle',
      unlockAmount: 'Monto mínimo en pesos uruguayos. Usá 0 para desbloquear con cualquier compra.',
      unlockMode: 'Factura única: una compra. Acumulable: suma del día.',
      externalTicket:
        'Desbloqueo al escanear un QR especial. Cargá Id sistema, Id emisor e Id beneficio del ticket.',
      qrSystemId: 'Código numérico de hasta 4 dígitos.',
      qrIssuerId: 'Código numérico de hasta 4 dígitos.',
      qrBenefitId: 'Un dígito del 0 al 9.',
      inactiveSelection: 'Inactivo',
    },
    fields: {
      type: 'Tipo',
      applicationScope: 'Alcance',
      active: 'Activo',
      amount: 'Monto',
      mode: 'Modo',
      externalTicket: 'QR especial',
      title: 'Título',
      shortTitle: 'Título corto',
      description: 'Descripción',
      additionalText: 'Texto adicional',
      images: 'Imágenes',
      icon: 'Ícono',
      image: 'Imagen',
      brands: 'Marcas',
      qrSystemId: 'Id sistema',
      qrIssuerId: 'Id emisor',
      qrBenefitId: 'Id beneficio',
      tags: 'Tags',
      levels: 'Niveles',
      duration: 'Tiempo',
      minutes: 'Minutos',
      hours: 'Horas',
      isFree: 'Parking libre / ilimitado',
      validFrom: 'Inicio de vigencia',
      validTo: 'Fin de vigencia',
    },
    scope: {
      none: 'Todas las marcas y tags',
      brands: 'Marcas',
      tags: 'Tags',
    },
    durationUnits: {
      minutes: 'min',
      hours: 'h',
    },
    upload: {
      iconRequired: 'Subir ícono *',
      icon: 'Subir ícono',
      imageRequired: 'Subir imagen *',
      image: 'Subir imagen',
      selectBrands: 'Seleccionar marcas',
      selectTags: 'Seleccionar tags',
      addBrands: 'Agregar...',
      addTags: 'Agregar...',
      search: 'Buscar',
    },
    validation: {
      completeRequired: 'Completá todos los datos requeridos',
      titleRequired: 'El título es requerido',
      titleMaxLength: 'No puede superar los 70 caracteres',
      shortTitleRequired: 'El título corto es requerido',
      shortTitleMaxLength: 'No puede superar los 100 caracteres',
      descriptionRequired: 'La descripción es requerida',
      descriptionMaxLength: 'No puede superar los 500 caracteres',
      additionalTextRequired: 'El texto adicional es requerido',
      additionalTextMaxLength: 'No puede superar los 30 caracteres',
      iconRequired: 'El ícono es requerido.',
      imageRequired: 'La imagen es requerida.',
      levelsRequired: 'Seleccioná al menos un nivel.',
      levelsRequiredWithMinutes:
        'Seleccioná al menos un nivel con tiempo mayor a 0 (horas o minutos).',
      validityRequired: 'Seleccioná la fecha de inicio y de fin de vigencia.',
      validityRange: 'La fecha de fin debe ser igual o posterior a la de inicio.',
      brandsRequired: 'Seleccioná al menos una marca.',
      qrIdentityRequired: 'Completá Id sistema, Id emisor e Id beneficio.',
      tagsRequired: 'Seleccioná al menos un tag.',
    },
    errors: {
      createFailed: 'No se pudo crear la configuración de parking. Intente de nuevo.',
      updateFailed: 'No se pudo actualizar la configuración de parking. Intente de nuevo.',
      deleteFailed: 'No se pudo eliminar la configuración de parking. Intente de nuevo.',
      toggleActiveFailed: 'No se pudo cambiar el estado activo. Intente de nuevo.',
      orderFailed: 'No se pudo guardar el orden de los beneficios. Intente de nuevo.',
    },
    order: {
      action: 'Ordenar beneficios',
      title: 'Ordenar beneficios',
      hint: 'Arrastrá los beneficios de cada nivel para definir el orden que se mostrará en la app.',
      previewTitle: 'Todos los beneficios del programa',
      emptyLevel: 'Este nivel aún no tiene beneficios para mostrar.',
      parkingBadge: 'Parking',
      dragHandle: 'Arrastrar beneficio',
    },
  },
}
